// @MX:ANCHOR: [AUTO] ECOUNT ETL 운영 가시성 API 모듈 — 5 endpoint (GET 3 + POST 2)
// @MX:REASON: [AUTO] SessionPanel/OapiQuotaBadge/BatchHealthPanel 3 컴포넌트 + useObservability가 경유. fan_in >= 4
// @MX:SPEC: SPEC-ECOUNT-ETL-OBSERVABILITY-001 §4, Phase β

import chinaInapi from './chinaInapi';

/**
 * ECOUNT ETL 운영 가시성 API 모듈 — china-inapi 5 endpoints proxy
 * baseURL: VUE_APP_CHINA_INAPI_URL
 * Authorization: Bearer <운영자(XINLAIAN) JWT>
 *
 * GET 3종 — 모든 인증 사용자 허용
 * POST 2종 — SUPER_ADMIN (JWT.role==='XINLAIAN') 전용
 *
 * Batch unreachable 분기: 200 + { status: 'unreachable', reason: '...' } 반환
 * → FE에서 response.data.status === 'unreachable' 분기 처리 필요
 */
const ecountEtlObservabilityApi = {
  /**
   * ECAPI 세션 상태 조회
   * GET /ecount-etl/session
   * 응답: SessionStatsDto 8 필드 | UnreachableResponseDto
   * @returns {Promise<AxiosResponse>}
   */
  getSession() {
    return chinaInapi.get('/ecount-etl/session');
  },

  /**
   * OAPI 일별 한도 조회
   * GET /ecount-etl/quota
   * 응답: OapiQuotaDto 7 필드 | UnreachableResponseDto
   * @returns {Promise<AxiosResponse>}
   */
  getQuota() {
    return chinaInapi.get('/ecount-etl/quota');
  },

  /**
   * Batch Health 조회 (컨테이너 up/down + Mongo ping + EtlRun 7일 집계)
   * GET /ecount-etl/health
   * 응답: BatchHealthDto 6 필드 | UnreachableResponseDto
   * @returns {Promise<AxiosResponse>}
   */
  getHealth() {
    return chinaInapi.get('/ecount-etl/health');
  },

  /**
   * ECAPI 세션 수동 재로그인 (SUPER_ADMIN 전용)
   * POST /ecount-etl/session/reauth
   * 응답: SessionStatsDto 8 필드 + { slackNotified: boolean }
   * 403: 비-SUPER_ADMIN 접근 시
   * @returns {Promise<AxiosResponse>}
   */
  postSessionReauth() {
    return chinaInapi.post('/ecount-etl/session/reauth');
  },

  /**
   * ECAPI 세션 강제 만료 (SUPER_ADMIN 전용)
   * POST /ecount-etl/session/invalidate
   * 응답: SessionStatsDto (state=NONE) + { slackNotified: boolean }
   * 403: 비-SUPER_ADMIN 접근 시
   * @returns {Promise<AxiosResponse>}
   */
  postSessionInvalidate() {
    return chinaInapi.post('/ecount-etl/session/invalidate');
  },
};

export default ecountEtlObservabilityApi;

export const {
  getSession,
  getQuota,
  getHealth,
  postSessionReauth,
  postSessionInvalidate,
} = ecountEtlObservabilityApi;

/**
 * Batch unreachable 응답 여부 확인
 * @param {*} data - axios response.data
 * @returns {boolean}
 */
export function isUnreachable(data) {
  return data && data.status === 'unreachable';
}
